import React from 'react';
import { SystemEntity } from "@backstage/catalog-model";
import { AppBar, Tabs, Tab } from "@material-ui/core";

import { FeaturesMonitoringSubpage } from './FeaturesMonitoringSubpage';
import { FeaturesChangeSubpage } from './FeaturesChangeSubpage';
import { microsoftAuthApiRef, useApi } from '@backstage/core-plugin-api';
import useAsync from 'react-use/esm/useAsync';

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {

  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  );
}

export const SystemFeatureFlagPage = ({system}: { system: SystemEntity }) => {

  const [tabValue, setTabValue] = React.useState(0);

  const authApi = useApi(microsoftAuthApiRef);

  const { value: loggedUserIsSystemOwner } = useAsync(async () => {
    const ownerGroup = system.relations?.find(relation => relation.type === 'ownedBy');
    if(!ownerGroup)
      return null;

    const identity = await authApi.getBackstageIdentity();
    return identity?.identity.ownershipEntityRefs?.some((entityRef) => entityRef === ownerGroup.targetRef);

  }, [authApi]);


  return (
    <>
      <AppBar position="sticky" role="complementary" >
        <Tabs
          value={tabValue}
          onChange={(event, newValue) => setTabValue(newValue)}
          variant="fullWidth"
          centered
        >
          <Tab label="MONITORING"/>
          <Tab label="CHANGE" disabled={!loggedUserIsSystemOwner} />
        </Tabs>
      </AppBar>
      
      <TabPanel value={tabValue} index={0}>
        {tabValue === 0 && <FeaturesMonitoringSubpage system={system} />}
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        { tabValue === 1 && <FeaturesChangeSubpage system={system}/>}
      </TabPanel>
    </>
  );
};
